import MapsApiBaseService from './MapsApiBaseService';
import { DrawerEvents } from '../enums';
import DrawEntityFactory from './DrawingAreaService/DrawEntityFactory';

export default class DrawingManagerService extends MapsApiBaseService {
  #drawing = null;
  #DrawingManager = null;

  async init() {
    await super.init();
    this.#drawing = this.googleMaps.drawing;
  }

  setDrawingOptions(drawingOptions, map) {
    if (this.#drawing) {
      if (!this.#DrawingManager) {
        this.createDrawingManager(map);
      }

      this.#DrawingManager.setOptions(drawingOptions);
    }
  }

  createDrawingManager(map) {
    this.#DrawingManager = new this.#drawing.DrawingManager();
    this.#DrawingManager.setMap(map);
  }

  setDrawingMode(drawingMode) {
    this.#DrawingManager.setDrawingMode(drawingMode);
  }

  addListener(callback) {
    const eventHandler = (event) => {
      const DrawingEntity = DrawEntityFactory.getDrawEntity(event.type);
      const bounds = DrawingEntity.getAreaBounds(event.overlay);

      event.overlay.setMap(null);
      this.setDrawingMode(null);
      callback(bounds);
    };
    Object.values(DrawerEvents)
      .forEach((event) => this.addDrawingListener(event, eventHandler));
  }

  addDrawingListener(event, callback) {
    if (this.#DrawingManager) {
      this.googleMaps.event.addListener(this.#DrawingManager, event, callback);
    }
  }

  removeDrawing() {
    if (this.#DrawingManager) {
      this.removeAllListeners();
      this.#DrawingManager.setMap(null);
    }
  }

  removeAllListeners() {
    if (this.#DrawingManager) {
      this.googleMaps.event.clearInstanceListeners(this.#DrawingManager);
    }
  }
}
